export default __webpack_public_path__ + "28058e1b83e9e96b5bf5dea34890d861.svg";